/** FAC / ETC methods (hours). Keep in sync with src/services/evmForecastFormulas.js */

export const ETC_FORMULAS = [
  { id: 'cpi', label: 'Typical — BAC ÷ CPI', short: 'CPI', hint: 'EAC = BAC ÷ CPI. Remaining work at the same efficiency as to date.' },
  { id: 'atypical', label: 'Atypical — AC + (BAC − EV)', short: 'Atypical', hint: 'Past variance will not continue. ETC = remaining budget (BAC − EV).' },
  { id: 'cpi_spi', label: 'Composite — (BAC − EV) ÷ (CPI × SPI)', short: 'CPI×SPI', hint: 'Both cost and schedule performance apply to leftover work.' },
  { id: 'spi', label: 'Schedule — (BAC − EV) ÷ SPI', short: 'SPI', hint: 'Leftover work adjusted only for schedule performance.' },
  { id: 'p6_remain', label: 'P6 remaining (bottom-up)', short: 'P6 ETC', hint: 'ETC = Resource Assignments remaining units. FAC = AC + that ETC.' },
  { id: 'p6_remain_cpi', label: 'P6 remaining ÷ CPI', short: 'P6÷CPI', hint: 'Schedule leftover, then apply current efficiency.' },
  { id: 'ev_plus_remain', label: 'Earned + P6 remaining', short: 'EV+P6', hint: 'Histogram forecast: FAC = EV + P6 remaining (not AC + remaining).' },
  { id: 'bac', label: 'On plan — FAC = BAC', short: 'BAC', hint: 'Assume the job finishes exactly on the proposal budget.' }
];

export const DEFAULT_ETC_FORMULA = 'cpi';
const ETC_FORMULA_KEY = 'evm-etc-formula';

export function loadEtcFormula() {
  try {
    const v = localStorage.getItem(ETC_FORMULA_KEY);
    if (ETC_FORMULAS.some((f) => f.id === v)) return v;
  } catch { /* ignore */ }
  return DEFAULT_ETC_FORMULA;
}

export function saveEtcFormula(id) {
  try { localStorage.setItem(ETC_FORMULA_KEY, id); } catch { /* ignore */ }
}

function round2(n) {
  return Math.round(((Number(n) || 0) + Number.EPSILON) * 100) / 100;
}

export function applyEtcFormula(pmi, formulaId = DEFAULT_ETC_FORMULA) {
  const bac = Number(pmi?.bac) || 0;
  const ev = Number(pmi?.ev) || 0;
  const ac = Number(pmi?.ac) || 0;
  const cpi = Number(pmi?.cpi);
  const spi = Number(pmi?.spi);
  const remain = Number(pmi?.remaining_hours) || 0;
  const leftover = bac - ev;
  const id = ETC_FORMULAS.some((f) => f.id === formulaId) ? formulaId : DEFAULT_ETC_FORMULA;

  let fac = null;
  let etc = null;
  if (id === 'cpi') {
    fac = cpi > 0 ? bac / cpi : null;
    etc = fac != null ? fac - ac : leftover;
  } else if (id === 'atypical') {
    etc = leftover;
    fac = ac + etc;
  } else if (id === 'cpi_spi') {
    etc = (cpi > 0 && spi > 0) ? leftover / (cpi * spi) : leftover;
    fac = ac + etc;
  } else if (id === 'spi') {
    etc = spi > 0 ? leftover / spi : leftover;
    fac = ac + etc;
  } else if (id === 'p6_remain') {
    etc = remain;
    fac = ac + etc;
  } else if (id === 'p6_remain_cpi') {
    etc = cpi > 0 ? remain / cpi : remain;
    fac = ac + etc;
  } else if (id === 'ev_plus_remain') {
    fac = ev + remain;
    etc = fac - ac;
  } else if (id === 'bac') {
    fac = bac;
    etc = fac - ac;
  }

  fac = fac == null ? null : round2(fac);
  etc = etc == null ? null : round2(etc);
  return {
    formulaId: id,
    formula: ETC_FORMULAS.find((f) => f.id === id),
    fac,
    etc,
    vac: fac == null ? null : round2(bac - fac),
    eac: fac
  };
}
